import React from "react";
import Box from "@mui/material/Box";
import { HashLink } from "react-router-hash-link";
const SimpleNavbar = () => {
	return (
		<Box
			sx={{
				width: 1,
				py: 2,
				backgroundColor: "#f9f8f8",
				boxShadow:
					"rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
				display: "flex",
				justifyContent: "center",
			}}
		>
			<HashLink to="/" smooth>
				<img
					src="/img/heslet_logo.png"
					width="30"
					alt="logo"
					style={{ position: "relative", top: "-4px" }}
				/>
			</HashLink>
		</Box>
	);
};

export default SimpleNavbar;
